import { motion } from "framer-motion";
import { Laurel } from "@/components/Laurel";

const AWARDS = [
    { id: "sundance", label: <>Official Selection<br />Sundance Film Festival 2025</> },
    { id: "tiff", label: <>Official Selection<br />TIFF 2024</> },
    { id: "bafta", label: <>BAFTA Film Award<br />Nominee 2011</> },
    { id: "ffi", label: <>FFI Nominated<br />Best VFX</> },
    { id: "ves", label: <>VES Award<br />Nominee 2011</> },
    { id: "ofta", label: <>OFTA Film Award<br />Nominee 2011</> },
];

export default function AwardsStrip() {
    return (
        <motion.section
            data-testid="awards-strip"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 1.2, delay: 0.2 }}
            className="relative border-y border-white/5 bg-[#050505] px-4 py-8"
            aria-label="Awards and festival selections"
        >
            <div className="mx-auto flex max-w-5xl flex-wrap items-center justify-center gap-x-6 gap-y-4 text-neutral-500">
                {AWARDS.map((a) => (
                    <Laurel key={a.id} testid={`award-laurel-${a.id}`}>
                        {a.label}
                    </Laurel>
                ))}
            </div>
        </motion.section>
    );
}
